import React from 'react';
import { SkinPageProps } from '../SkinPage';
import Page from '../../Page';
import styles from './styles/VerySimpleSkin.scss';

const VerySimpleSkin: React.FC<SkinPageProps> = ({
  id,
  pageDidMount,
  onClick,
  onDblClick,
  children,
  onMouseEnter,
  onMouseLeave,
}) => {
  return (
    <div
      id={id}
      className={styles.pageWrapper}
      ref={pageDidMount}
      onClick={onClick}
      onDoubleClick={onDblClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {children()}
    </div>
  );
};

const VerySimplePage: React.FC<SkinPageProps> = props => (
  <Page {...props} skin={VerySimpleSkin} />
);

export default VerySimplePage;
